import { Component, OnInit } from '@angular/core';
import { BookingCredentials } from '../../booking-credentials';
import { Router } from '@angular/router';
import { LoginService } from 'src/app/Services/login.service';
import { AppConfigService } from 'src/app/Services/app-config.service';
import { UserData } from 'src/app/Models/employee-and-user-data';
import { AXLoginResponse } from 'src/app/Models/portal-login';
import { TripContextService } from 'src/app/Services/trip-context.service';
import { AuthTokenService } from 'src/app/Services/auth-token/auth-token.service';
import {
  voyagePmsCodeFromBookingEvtCode,
  axLoginPackageEvtPmsCode,
  legVoyageCode,
} from 'src/app/utils/voyage-pms-code';

@Component({
  selector: 'app-login-prompt',
  templateUrl: './login-prompt.component.html',
  styleUrls: ['./login-prompt.component.css'],
})
export class LoginPromptComponent implements OnInit {
  public OBPortalSvcURL = '';
  public userData: UserData = {};
  public loginmessage = '';

  logincredentials = new BookingCredentials();

  constructor(
    private appConfigService: AppConfigService,
    private router: Router,
    private loginservice: LoginService,
    private tripContextService: TripContextService,
    private authTokenService: AuthTokenService,
  ) {}

  ngOnInit(): void {
    this.OBPortalSvcURL = this.appConfigService.OBPortalSvcURL;
  }

  login() {
    this.loginmessage = '';

    this.loginservice
      .AXLogin(
        this.logincredentials.bookingcode ?? '',
        this.logincredentials.lastname ?? ''
      )
      .subscribe((res) => this.setLogin(res));
  }

  setLogin(res: AXLoginResponse) {
    if (res.result.status === 'A') {
        const d = res.data as AXLoginResponse['data'] & Record<string, unknown>;
        const firstLeg = d.eventLegs?.[0];
        const packageEvtPmsCode = axLoginPackageEvtPmsCode(d);
        const initialLegCode =
          legVoyageCode(firstLeg) ?? packageEvtPmsCode;

        this.userData = {
          rebcode: d.rebCode,
          rebuid: d.rebUid,
          evtPmsCode: voyagePmsCodeFromBookingEvtCode(packageEvtPmsCode),
          evtcode: voyagePmsCodeFromBookingEvtCode(initialLegCode),
          loyaltynum: d.folRepeaterNo,
          cruiseBeg: firstLeg?.evtBegDate,
          cruiseEnd: firstLeg?.evtEndDate,
          shipid: firstLeg?.shipUid,
          ShipName: firstLeg?.shipName,
          pckgBeg: d.packageStart,
          pckgEnd: d.packageEnd,
          legs: d.eventLegs,
          packagePckgBeg: d.packageStart,
          packageCruiseEnd: d.packageEnd,
          extended: false,
        };

        const ctx = this.tripContextService.resolve(this.userData);

        if (ctx.phase === 'on_leg' || ctx.phase === 'preview') {
            if (ctx.contentEvtCode) {
              this.userData.evtcode = voyagePmsCodeFromBookingEvtCode(
                ctx.contentEvtCode
              );
            }
            if (ctx.contentShipId)   this.userData.shipid = ctx.contentShipId;
            if (ctx.contentShipName) this.userData.ShipName = ctx.contentShipName;

            this.authTokenService.setToken(res.token);
            if (res.ipAddress) {
              localStorage.setItem('ipAddress', res.ipAddress);
            }

            this.RecordAccess(res.ipAddress);
            localStorage.setItem('userinfo', JSON.stringify(this.userData));
            localStorage.setItem('bookingcode', this.logincredentials.bookingcode);
            localStorage.setItem('shpid', String(this.userData.shipid ?? ''));

            this.router.navigate(['/menu']);
        } else if (ctx.phase === 'pre_package') {
            this.loginmessage =
              'We are excited to welcome you aboard. American Explorer will be available two weeks before your cruise package begins.';
        } else {
            this.loginmessage =
              'We hope you enjoyed your cruise. American Explorer is not available since your cruise has ended.';
        }
    } 
    
    // IF WE HAVE A RESPONSE OF NOT STATUS "R" OR STATUS "U" THEN WE ENTER THIS ELSE STATEMENT...
    else {

      // CASE - 1: IF WE RETURN THIS ERROR  MESSAGE SET THE LOGIN PAGE ERROR  MESSAGE...
      if (res.result.message === 'Booking not found') this.loginmessage = 'American Explorer is only available during your cruise';
      
      // CASE - 2: IF WE RETURN NULL DATA SET DISPLAY THAT SAME ERROR MESSAGE..
      if (res.data == null) this.loginmessage = 'American Explorer is only available during your cruise';

    }
  }

  RecordAccess(ipAddress: string | null) {
      // IF WE DON'T HAVE THE IP ADDRESS THEN WE WANT TO EXIT THIS FUNCTION EARLY
      // WE DON'T WANT TO WAIT FOR THIS API REQUEST TO FAIL...
      if (ipAddress == undefined || ipAddress == null || ipAddress == '') {
        console.error("Unable to extract end users ip address.");
        return;
      }

    this.loginservice
      .RecordAccess(
        this.logincredentials.bookingcode,
        true,
        ipAddress,
        'Guest',
        'login'
      )
      .subscribe();
  }
}
